import "./App.css";
import { useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import MobileStickyCTA from "./components/MobileStickyCTA";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import SmoothScroll from "./components/SmoothScroll";
import LangRouteWrapper from "./components/LangRouteWrapper";
import GoogleAdsPageTracker from "./components/GoogleAdsPageTracker";
import Home from "./pages/Home";
import { captureAttribution } from "./lib/attribution";

// Lazy chunks: not needed for the homepage LCP
const Blog = lazy(() => import("./pages/Blog"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const LegalPrivacy = lazy(() => import("./pages/Legal").then((m) => ({ default: m.PrivacyPage })));
const LegalTerms = lazy(() => import("./pages/Legal").then((m) => ({ default: m.TermsPage })));

function PageFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="w-10 h-10 border-2 border-[#FF5A1F] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

function SiteShell({ children }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => { captureAttribution(); }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <GoogleAdsPageTracker />
        <Suspense fallback={<PageFallback />}>
          <Routes>
            {/* Language-prefixed public routes */}
            <Route path="/:lang" element={<LangRouteWrapper />}>
              <Route index element={<SiteShell><Home /></SiteShell>} />
              <Route path="blog" element={<SiteShell><Blog /></SiteShell>} />
              <Route path="privacy" element={<SiteShell><LegalPrivacy /></SiteShell>} />
              <Route path="voorwaarden" element={<SiteShell><LegalTerms /></SiteShell>} />
            </Route>

            {/* Root = default (Dutch) — same content, no redirect */}
            <Route path="/" element={<SiteShell><Home /></SiteShell>} />
            <Route path="/blog" element={<SiteShell><Blog /></SiteShell>} />
            <Route path="/privacy" element={<SiteShell><LegalPrivacy /></SiteShell>} />
            <Route path="/voorwaarden" element={<SiteShell><LegalTerms /></SiteShell>} />

            {/* Admin (Dutch only, lazy chunk) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
        <Toaster position="top-right" richColors closeButton />
        <MobileStickyCTA />
        <FloatingWhatsApp />
      </BrowserRouter>
    </div>
  );
}

export default App;
